import { loadCacheFromLocalStorage, toRestoreGridPage } from '../../../helpers/localStorage';
import { INITIAL_SORT, ALL_COLUMNS, INITIAL_FILTERS, INITIAL_PAGE } from '../constants';

export const getInitialData = ({
  cacheKey,
  buildingId,
  inspectionSeriesId,
  accountId,
  enableMoveSeries,
  iimEnabled
}) => {
  const cache = loadCacheFromLocalStorage(cacheKey);
  if (cacheIsValid(cache, cacheKey)) {
    const columns =
      iimEnabled && !cache.columns.includes('unresolvedIssues')
        ? [...cache.columns, 'unresolvedIssues']
        : cache.columns;
    return {
      ...cache,
      columns,
      page: toRestoreGridPage() && cache.page ? cache.page : INITIAL_PAGE,
      search: '',
      data: [],
      totalCount: 0,
      selectAll: false,
      enableMoveSeries,
      loading: true
    };
  }

  return {
    page: INITIAL_PAGE,
    sort: INITIAL_SORT,
    filters: getInitialFilters(buildingId, inspectionSeriesId, accountId),
    columns: getInitialColumns(buildingId, inspectionSeriesId, accountId),
    search: '',
    data: [],
    totalCount: 0,
    selectAll: false,
    enableMoveSeries,
    loading: true
  };
};

export const getInitialFilters = (buildingId, inspectionSeriesId, accountId) => {
  if (buildingId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, building: buildingId } };
  }

  if (inspectionSeriesId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, inspectionSeries: inspectionSeriesId } };
  }

  if (accountId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, account: accountId } };
  }

  return INITIAL_FILTERS;
};

// Columns that live in the column menu but are never on by default. `visits` renders every
// visit date for the inspection, which is a wide cell most listings do not want unprompted.
// Deliberately NOT back-filled into a cached `columns` array the way `unresolvedIssues` is
// above — that injection exists to force a required column on; this one must stay opt-in.
const OPT_IN_COLUMNS = ['visits'];

const getInitialColumns = (buildingId, inspectionSeriesId, accountId) => {
  const columns = ALL_COLUMNS.filter((column) => !OPT_IN_COLUMNS.includes(column));

  if (buildingId || inspectionSeriesId) {
    return columns.filter((column) => column !== 'building');
  }

  if (accountId) {
    return columns.filter((column) => column !== 'account');
  }

  return columns;
};

const cacheIsValid = (cache, cacheKey) => {
  if (!cache) return false;

  if (
    cache.filters &&
    cache.filters.active &&
    cache.filters.values &&
    cache.filters.operators &&
    cache.sort &&
    !cache.columns.includes('selected')
  )
    return true;

  localStorage.removeItem(cacheKey);
  return false;
};
